import React from 'react';
import PropTypes from 'prop-types';

const PageCountButton = ({
	pageNumber,
	pagePath,
	pageButtonLink,
	handlePageClick
}) => {
	const tabIndexValue = pageNumber === '...' ? -1 : 0;

	return tabIndexValue !== -1 ? (
		<a
			href={`${pagePath}?${pageButtonLink}`}
			onClick={handlePageClick}
			// eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
			tabIndex={pageNumber === '...' ? -1 : 0}
		>
			{pageNumber}
		</a>
	) : (
		<span tabIndex={tabIndexValue}>{pageNumber}</span>
	);
};

PageCountButton.propTypes = {
	pageNumber: PropTypes.number.isRequired,
	pagePath: PropTypes.string.isRequired,
	pageButtonLink: PropTypes.string.isRequired,
	handlePageClick: PropTypes.func.isRequired
};

export default PageCountButton;
